import React from 'react';
import { Button } from '@vtbhome/juicyfront';
import { Body, Footer, Subscription } from './modal-lock-organization.styles';
import { ModalLockOrganizationProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { getOrganizationStatus } from '@shared/lib/utils/get-organization-status/get-organization-status';
import { useOrganizationLockMutation } from '../../api/organization-lock-api';
import { CACHE_KEY_ORGANIZATION_LOCK } from '../../config/api-constants';
import { CardOrganizationPreview } from '@entities/organization/ui/card-organization-preview/card-organization-preview';
import { Modal } from '@shared/ui/modal/modal';

export const ModalLockOrganization: React.FC<ModalLockOrganizationProps> = ({
    isShow,
    organization,
    onClose,
    onAccept,
}) => {
    const [lockOrganization, lockOrganizationResult] = useOrganizationLockMutation({
        fixedCacheKey: CACHE_KEY_ORGANIZATION_LOCK,
    });
    const isDisabledOrganization = getOrganizationStatus(organization) === 'disabled';
    const isLoading = lockOrganizationResult.isLoading;

    const handleAccept = async () => {
        await lockOrganization({
            id: organization.id,
            active: !organization.active,
        });
        onAccept();
    };

    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={
                <Typography size='h5'>
                    <b>{isDisabledOrganization ? 'Разблокировать организацию' : 'Заблокировать организацию'}</b>
                </Typography>
            }
            footer={
                <Footer>
                    <Button disabled={isLoading} buttonType='light' onClick={onClose}>
                        Отменить
                    </Button>
                    <Button preloader={isLoading} disabled={isLoading} buttonType='primary' onClick={handleAccept}>
                        Подтвердить
                    </Button>
                </Footer>
            }
            onClose={onClose}>
            <Body>
                <Subscription size='body1_short' as='p'>
                    {isDisabledOrganization
                        ? 'Вы действительно хотите разблокировать данную организацию? Вместе с организацией будут разблокированы все сотрудники и менеджеры, прикрепленные к данной организации'
                        : 'Вы действительно хотите заблокировать данную организацию? Вместе с организацией будут заблокированы все сотрудники и менеджеры, прикрепленные к данной организации'}
                </Subscription>
                <CardOrganizationPreview organization={organization} />
            </Body>
        </Modal>
    );
};
